module.exports = __webpack_public_path__ + "static/media/hamburger.1020d040.svg";